// extracted by mini-css-extract-plugin
module.exports = {"hasBadge":"NavBar_hasBadge__mxKlf","iconButton":"NavBar_iconButton__ifbNB","balance":"NavBar_balance__1KPol","ping":"NavBar_ping__a_l7S"};